import React from "react";
import Slider from "react-slick";

import HeadingWithIcon from "./HeadingWithIcon";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { TestimonialsContainer } from "./Testimonials.style";

// Images
import TestimonialGraphicImg from "../../Assets/Images/LandingPage/testimonial_graphic_img.png";
import { testimonials } from "Components/Pages/Testimonials/TestimonialsPage";

const TestimonialsSection = () => {
    const settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: true,
    };

    return (
        <TestimonialsContainer>
            <div className="testimonials_section">
                <div className="mygrid-container">
                    <div className="testimonial-inner-wrapper">
                        <div className="testi-graphic-img">
                            <img src={TestimonialGraphicImg} alt="testimonials-img" />
                        </div>

                        <div className="testimonial_cara">
                            <h5 className="subheading">Testimonials</h5>
                            <HeadingWithIcon highlight=" & Families Are Saying">
                                What Educators <br />
                            </HeadingWithIcon>
                            <p>Don’t just take our word for it, see how Subjects Master is transforming classrooms and home learning across the country. From boosted engagement to better test scores, hear directly from the teachers and parents who have seen the difference game-based learning makes.</p>

                            {/* React-Slick Slider */}
                            <div className="testimonial_slider_wrap">
                                <Slider {...settings}>
                                    {testimonials.map((item, index) => (
                                        <div className="testimonial_item" key={index}>
                                            <p className="testimonial_desc">{item.content}</p>
                                            <h4 className="testimonial_name">{item.name}</h4>
                                            <p className="testimonial_position">{item.role}</p>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </TestimonialsContainer>
    );
};

export default TestimonialsSection;
